module.exports = __webpack_public_path__ + "static/media/ic_dmt_report.4bc7e019.png";